<script>
    import EducatorTemplate from '../../../common/EducatorTemplate'

    export default {
        components: {
            EducatorTemplate
        },
        created: () => {

        },
        async mounted () {
            this.uid = await this.$store.getters.getCurrentUID
            console.log("educator profile; this.uid is " + this.uid)
            var educator = await this.$store.getters.getEducator(this.uid)
            if ( educator != undefined ) {
              this.educator = educator.val()

            }
            this.educatorID = this.uid
        },
        data() {
            return {
                uid: "",
                mykey: 'bar',
                educator: {},
                educatorID: ""
            }
        },
        computed: {
          needMoreInfo: function() {
            return !(this.educator.fName)
          }
        },
        methods: {

        }
        
    }
</script>

<template lang="pug">
  .foo
    .row#lackingInfo( v-if="needMoreInfo")
      .col.s8.offset-s2.center#notEnoughInfo
        h5 Your profile does not currently have enough information to display to companies. Please edit each section of your profile by clicking the pencil icon.
    educator-template( :educator="educator" :educatorID="educatorID" :editable="true" )  
</template>

<style lang="sass" scoped>




</style>